module.exports = __webpack_public_path__ + "media/images/emblems/Neuenegg-coat_of_arms-eada2beb4c9342736219a6eb52e4bcc9.svg";